import React from "react";
import { Navigate, useLocation  } from "react-router-dom";

// ProtectedRoute component
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  // const isAuthenticated = true; // Replace `true` with actual authentication logic

  // return isAuthenticated ? <>{children}</> : <Navigate to="/" />;
  const token = localStorage.getItem("userToken");

  if(!token){return  <Navigate to="/" state={{ fromProtectedPage: false }}/>;} 
  return children;
};

export default ProtectedRoute;
